import { useEffect, useState } from 'react';
import classNames from 'classnames';
import { Checkbox } from '@hh.ru/magritte-ui';
import styles from './StoreDevHelperProvider.module.less';
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
let _StoreDevHelperProvider = ({
  children
}) => /*#__PURE__*/_jsx(_Fragment, {
  children: children
});
const showDevInfoToConsole = () => {
  // eslint-disable-next-line no-console
  console.log("%cВнимание разработчик! Тебе доступна 'store' утилита (позволяет получать текущее состояние и подписываться" + ' на изменения' + ' в redux store). Дока: https://forgejo.pyn.ru/hhru/front-packages/src/master/redux-dev-helper.' + ' Пример: window.store.myService.myPlace(); Для удобства используй UI, который вызывается с помощью комбинации клавиш: Ctrl + Shift + 1.', 'font-size: 14px;');
};
if (process.env.HH_BUILD_MODE === 'development') {
  const StoreDevHelperRenderer = ({
    serviceName,
    place = 'page',
    onVisible
  }) => {
    const [isControlsVisible, setIsControlsVisible] = useState(false);
    const [isIncludeUnchangedFields, setIsIncludeUnchangedFields] = useState(true);
    const [fieldValue, setFieldValue] = useState('');
    const [isFieldNotFound, setIsFieldNotFound] = useState(false);
    const handleStore = window.store[serviceName][place];
    const handleStoreAction = actionCallback => {
      const result = handleStore(fieldValue || '', isIncludeUnchangedFields);
      if (fieldValue && Object.keys(result).length === 0) {
        console.warn(`Поле ${fieldValue} отсутствует в ${serviceName}: ${place}`);
        setIsFieldNotFound(true);
        return;
      }
      actionCallback(result);
      setIsFieldNotFound(false);
    };
    const drawStoreToConsole = () => {
      handleStoreAction(result => {
        // eslint-disable-next-line no-console
        console.log(`Service: ${serviceName}, Place: ${place}`, result);
      });
    };
    const subscribeToStore = () => {
      handleStoreAction(() => {
        handleStore.subscribe(fieldValue || '', isIncludeUnchangedFields);
      });
    };
    const unSubscribeFromStore = () => {
      handleStore.unsubscribe();
    };
    const handleShowStores = () => {
      setIsControlsVisible(value => !value);
    };
    useEffect(() => {
      onVisible(isControlsVisible);
    }, [onVisible, isControlsVisible]);
    useEffect(() => {
      showDevInfoToConsole();
      const handleKeydown = event => {
        if (event.ctrlKey && event.shiftKey && event.key === '1') {
          event.preventDefault();
          handleShowStores();
        }
      };
      document.addEventListener('keydown', handleKeydown);
      return () => {
        document.removeEventListener('keydown', handleKeydown);
      };
    }, []);
    if (!isControlsVisible) {
      return null;
    }
    return /*#__PURE__*/_jsx("div", {
      className: styles.storeControl,
      children: /*#__PURE__*/_jsxs("div", {
        className: styles.storeControlInner,
        children: [/*#__PURE__*/_jsxs("span", {
          children: ["Service Name: ", /*#__PURE__*/_jsx("b", {
            children: serviceName
          }), ". Place: ", /*#__PURE__*/_jsx("b", {
            children: place
          })]
        }), /*#__PURE__*/_jsx("input", {
          className: classNames(styles.fieldInput, isFieldNotFound && styles.fieldError),
          type: "text",
          placeholder: "Store Field: All",
          value: fieldValue,
          list: `field-list-${serviceName}-${place}`,
          onChange: event => {
            setFieldValue(event.target.value);
          }
        }), /*#__PURE__*/_jsx("datalist", {
          id: `field-list-${serviceName}-${place}`,
          children: Object.keys(handleStore()).map(fieldName => {
            return /*#__PURE__*/_jsx("option", {
              value: fieldName
            }, fieldName);
          })
        }), /*#__PURE__*/_jsx("button", {
          className: styles.drawStoreBtn,
          type: "button",
          onClick: () => {
            drawStoreToConsole();
          },
          children: "Log store"
        }), /*#__PURE__*/_jsx("button", {
          className: styles.drawStoreBtn,
          type: "button",
          onClick: () => {
            subscribeToStore();
          },
          children: "Subscribe"
        }), /*#__PURE__*/_jsx("button", {
          className: styles.drawStoreBtn,
          type: "button",
          onClick: () => {
            unSubscribeFromStore();
          },
          children: "Unsubscribe"
        }), /*#__PURE__*/_jsxs("label", {
          className: styles.label,
          children: [/*#__PURE__*/_jsx(Checkbox, {
            checked: isIncludeUnchangedFields,
            onChange: () => {
              setIsIncludeUnchangedFields(value => !value);
            }
          }), "Include unchanged fields"]
        })]
      })
    });
  };
  const StoreDevHelperProviderPrivate = ({
    serviceName,
    place,
    children
  }) => {
    const [isVisibleOnClient, setIsVisibleOnClient] = useState(false);
    const [isControlsVisible, setIsControlsVisible] = useState(false);
    useEffect(() => {
      setIsVisibleOnClient(true);
    }, []);
    return /*#__PURE__*/_jsxs("div", {
      className: isControlsVisible ? styles.storeControlContainer : '',
      children: [isVisibleOnClient && /*#__PURE__*/_jsx(StoreDevHelperRenderer, {
        serviceName: serviceName,
        place: place,
        onVisible: setIsControlsVisible
      }), children]
    });
  };
  _StoreDevHelperProvider = StoreDevHelperProviderPrivate;
}
const StoreDevHelperProvider = _StoreDevHelperProvider;
export default StoreDevHelperProvider;
//# sourceMappingURL=index.js.map